
export default {

    setMailings(state, mailings) {
        state.mailings = mailings;
    },
    setRequest(state, request) {
        state.request = request;
    },
    setMailchimpTemplates(state, templates) {
        state.mailchimpTemplates = templates;
    }
}